module.exports = __webpack_public_path__ + "img/6.38323735.jpg";